import React from 'react';

const SortIcon: React.FC<{ direction: 'ASC' | 'DESC' }> = ({ direction }) => (
  <svg
    className="pt-icon"
    style={{ height: 16, width: 16 }}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d={direction === 'DESC'
        ? "M3 6h10M3 12h7M3 18h4m13-6l-3 3m0 0l-3-3m3 3V5"
        : "M3 6h4M3 12h7M3 18h10m10-6l-3-3m0 0l-3 3m3-3v10"
      }
    />
  </svg>
);

export default SortIcon;
